import type { CrossroadsMappingType } from '@/api/types'
import { ICellEditorParams } from 'ag-grid-community'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { RefDataSourceIdsSelect } from './RefDataSourceIdsSelect'

interface RefDataSourceIdsEditorProps extends ICellEditorParams {
  value: string[]
  sourceSystem: string | undefined
  mappingType: CrossroadsMappingType
  placeholder?: string
}

export const RefDataSourceIdsEditor = forwardRef<
  {
    getValue: () => string[]
    isCancelBeforeStart: () => boolean
    isCancelAfterEnd: () => boolean
  },
  RefDataSourceIdsEditorProps
>((props, ref) => {
  const { value: defaultValue, sourceSystem, mappingType, placeholder } = props

  const cellWidth = props.column?.getActualWidth()
  const cellHeight = props.eGridCell?.offsetHeight

  const [value, setValue] = useState<string[]>(defaultValue ?? [])

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    isCancelBeforeStart: () => false,
    isCancelAfterEnd: () => false,
  }))

  return (
    <RefDataSourceIdsSelect
      value={value}
      onChange={setValue}
      sourceSystem={sourceSystem}
      mappingType={mappingType}
      placeholder={placeholder}
      width={cellWidth}
      height={cellHeight}
      autoFocus
      defaultOpen
    />
  )
})
